import { defineComponent as e } from "vue";
const t = e({
  name: "LogoBBB",
  props: {
    link: {
      type: String,
      required: !0
    },
    imageLink: {
      type: String,
      required: !0
    },
    imageAlternateText: {
      type: String,
      required: !0
    }
  }
});
export {
  t as default
};
//# sourceMappingURL=index9.js.map
